import { FC } from 'react';
import EditProjectFormNew from '@app/modules/projects/inputs/project-admin-new/project-form/EditProjectForm';

const ProjectDetails: FC = (): JSX.Element => {
  return <EditProjectFormNew />;
};

export default ProjectDetails;
